









































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateConversationTopicRequest from '@/models/ConversationTopics/UpdateConversationTopicRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';
import AgencyGroupStatus from '@/models/AgencyGroups/AgencyGroupStatus';
import ConversationTopicType from '@/models/ConversationTopics/ConversationTopicType';

@Component({
    name: 'ConversationTopicEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new ConversationTopicDto();
  conversationTopicType = ConversationTopicType;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentConversationTopic));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get businessHours() {
    return AgencySettingsModule.businessHours;
  }

  get groups() {
    return AgencySettingsModule.agencyGroups.filter(function(agencyGroup){
      if (agencyGroup.status === AgencyGroupStatus.Active ) {
        return true;
      }
      return false;
    })
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateConversationTopicRequest();
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.isPublic = this.entity.isPublic;
    request.isEnabled = this.entity.isEnabled;
    request.businessHoursId = this.entity.businessHours.id;
    request.isBusinessHoursNotificationEnabled = this.entity.isBusinessHoursNotificationEnabled;
    request.businessHoursGroupId = this.entity.businessHoursGroup.id;
    request.outOfHoursGroupId = this.entity.outOfHoursGroup.id;
    request.isOutOfHoursNotificationEnabled = this.entity.isOutOfHoursNotificationEnabled;
    request.offlineMessage = this.entity.offlineMessage;
   
    await AgencySettingsModule.editConversationTopic(request);
    this.dialog = false;
  }
}
